import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { SenderService } from '@mailer/services/SenderService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => SenderService.getList(params)
    }
  },
  true
);
